import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'app-skill-list',
    templateUrl: './skill-list.component.html',
    styleUrls: ['./skill-list.component.css']
})
export class SkillListComponent {
  @Input() skillList;
  @Input() totalSkill;
  @Input() loading;
  @Input() empty;
  @Input() locale;

  @Output() onClickLoadMore = new EventEmitter<any>();
  @Output() onClick = new EventEmitter<any>();

  onLoadMore($event) {
    this.onClickLoadMore.emit($event);
  }
  onSkillClick($event) {
    this.onClick.emit($event);
  }

}
